import type { InvoiceConfigInfo, InvoiceConfigInfoInvoiceConfigSchema } from '~/server_shared/openapi/data-contracts';

import useDataFetcher from '../useDataFetcher';

/**
 * Resolves the invoice config for an organization (org-wide singleton).
 */
export const useInvoiceConfig = (
  organizationId: number
): { invoiceConfig: InvoiceConfigInfoInvoiceConfigSchema | null; isLoading: boolean } => {
  const { isLoading, data } = useDataFetcher<InvoiceConfigInfo | null>(
    `/api/v1/organizations/${organizationId}/invoice_config`
  );
  return { invoiceConfig: data?.config ?? null, isLoading };
};
